import { motion } from "framer-motion";

// Generic scroll-into-view reveal
export function Reveal({ children, delay = 0, y = 40, className = "", ...rest }) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
            className={className}
            {...rest}
        >
            {children}
        </motion.div>
    );
}

// Masked line-by-line reveal used in the hero
export function MaskLine({ children, delay = 0, className = "" }) {
    return (
        <span className="block overflow-hidden">
            <motion.span
                className={`block ${className}`}
                initial={{ y: "110%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
            >
                {children}
            </motion.span>
        </span>
    );
}
